import { differenceInCalendarWeeks } from 'date-fns'
export function getDifference(date) {
  let diffInWeeks = differenceInCalendarWeeks(date, new Date())
  return '+' + diffInWeeks
}
